import moment from "moment";
import { FC, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import Button from '../../Button';
import styled from "styled-components";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import { IGetNotifications, INotificationItem } from "../../../models/notification.model";
import _ from "lodash";
import CreateNoticeModal from "./modals/CreateNoticeModal";
import ShowNoticeModal from "./modals/ShowNoticeModal";
import useAxios from "../../../hooks/useAxios";
import { getNotifications } from "../../../api/notification.api";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

const Block = styled.div`
  .arrow > * {
    font-size: 24px;
  }

  .date {
    font-size: 18px;
  }

  .rbc-event {
    text-align: center;
  }
`;

moment.locale('ko');
const localizer = momentLocalizer(moment);

interface IProps {
  classCode: string;
  className?: string|undefined;
  isTutor?: boolean;
}

const ClassNotice: FC<IProps> = ({
  classCode,
  className,
  isTutor = false,
}) => {
  const { t, i18n } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: res, isLoading, error, execute } = useAxios<IGetNotifications>();

  const [data, setData] = useState<INotificationItem[]>([]);
  const [event, setEvent] = useState<any>();
  const [events, setEvents] = useState([]);
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [day, setDay] = useState(0);
  const [date, setDate] = useState<any>();
  const [createNoticeVisible, setCreateNoticeVisible] = useState(false);
  const [showNoticeVisible, setShowNoticeVisible] = useState(false);

  useEffect(() => {
    if (classCode) {
      doGetClassNotice();
    }
  }, [classCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (data) {
      const _data = _.cloneDeep(data).sort((a: any, b: any) => a.timetableDate < b.timetableDate ? -1 : (a.timetableDate > b.timetableDate ? 1 : 0));
      const _events: any = [];
      _data.forEach((item, index) => {
        const year = Number(item.timetableDate.slice(0, 4));
        const month = Number(item.timetableDate.slice(4, 6)) - 1;
        const day = Number(item.timetableDate.slice(6));
        _events.push({
          id: item.timetableCode,
          title: `${t('class.class.button13')}`,
          allDay: true,
          start: new Date(year, month, day),
          end: new Date(year, month, day + 1),
          resource: {
            type: 'new',
            index,
            semesterCourseCode: item.semesterCourseCode,
            timetableSeq: item.timetableSeq,
          }
        });
        item.notifications.forEach(subitem => {
          if (subitem.notificationCode) {
            _events.push({
              id: subitem.notificationCode,
              title: subitem.subjectName,
              // title: getSubjectInitial(subitem.subjectName || ''),
              allDay: true,
              start: new Date(year, month, day),
              end: new Date(year, month, day + 1),
              resource: {
                type: subitem.subjectName,
                index,
                semesterCourseCode: item.semesterCourseCode,
                timetableSeq: item.timetableSeq,
              }
            });
          }
        })
      });
      setEvents(_events);
    }
  }, [data]);

  useEffect(() => {
    if (serverDate) {
      const _date = moment(serverDate);
      setYear(Number(_date.format('YYYY')));
      setMonth(Number(_date.format('M')) - 1);
      setDay(Number(_date.format('D')));
      setDate(_date);
    }
  }, [serverDate]);

  const doGetClassNotice = () => {
    if (!classCode) return;
    execute(getNotifications(classCode));
  }

  const onSetPrevMonth = () => {
    if (month === 0) {
      setYear(year - 1);
      setMonth(11);
    } else {
      setMonth(month - 1);
    }
    setDay(1);
  }

  const onSetNextMonth = () => {
    if (month === 11) {
      setYear(year + 1);
      setMonth(0);
    } else {
      setMonth(month + 1);
    }
    setDay(1);
  }

  const setToday = () => {
    setYear(Number(date.format('YYYY')));
    setMonth(Number(date.format('M')) - 1);
    setDay(Number(date.format('D')));
  }

  // const getSubjectInitial = (subjectName: string) => {
  //   switch (subjectName) {
  //     case 'Phonics':
  //       return 'P';
  //     case 'Reading':
  //       return 'R';
  //     case 'Grammar':
  //       return 'G';
  //     case 'Novel':
  //       return 'NV';
  //     case 'Writing':
  //       return 'W';
  //     case 'Speaking':
  //       return 'S';
  //     case 'Listening':
  //       return 'L';
  //     case 'Musical':
  //       return 'M';
  //     case 'Newspaper':
  //       return 'NP';
  //     default:
  //       return subjectName;
  //   }
  // }

  const onOpenCalendarEvent = (e: any) => {
    setEvent(e);

    if (e.resource.type === 'new') {
      // if (writeAuthYn === 'Y')
        setCreateNoticeVisible(true);
      // else
      //   return infoNotification('등록 권한이 없습니다.');
    } else {
        setShowNoticeVisible(true);
    }
  }  

  return (
    <Block>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      {
        isTutor
          ? null
          : (
            <h5 className="text-left my-2">
              {chosenClass?.className}
            </h5>
            )
      }
      <div className="mx-3 mt-3 flex">
        <div className="col-2">
          <Button
            className="btn btn-sm btn-primary btn-w100p"
            onClick={setToday}
            text={t('class.class.button9')}
          />
        </div>
        <div className="col-8 text-center">
          <h5>
            <span className="arrow mr-3 pointer">
              <AiOutlineLeftCircle onClick={onSetPrevMonth} />
            </span>
            <span className="date">
              {year}{t('class.class.text25')} {month + 1}{t('class.class.text26')}
            </span>
            <span className="arrow ml-3 pointer">
              <AiOutlineRightCircle onClick={onSetNextMonth} />
            </span>
          </h5>
        </div>
        <div className="col-2" />
      </div>
      <div>
        <Calendar
          localizer={localizer}
          culture={i18n.language === 'ko' ? 'ko-KR' : 'en-US'}
          events={events}
          date={new Date(year, month, day)}
          onSelectEvent={e => onOpenCalendarEvent(e) }
          selectable
          toolbar={false}
          style={{ minHeight: '850px', margin: '10px' }}
          // @ts-ignore
          dayPropGetter={date => {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return { style: { background: '#e6e6e6' } }
            }
          }}
          // @ts-ignore
          eventPropGetter={(event: any) => {
            switch (event.resource.type) {
              case 'new':
                return { style: { background: 'darkgray' } }
              default:
                return { style: { background: '#65c1c1' } }
            }
          }}
          dayLayoutAlgorithm='no-overlap'
        />
      </div>

      {
        createNoticeVisible &&
          <CreateNoticeModal
            visible={createNoticeVisible}
            setVisible={setCreateNoticeVisible}
            event={event}
            doGetClassNotice={doGetClassNotice}
            isTutor={isTutor}
            className={className}
          />
      }
      {
        showNoticeVisible &&
          <ShowNoticeModal
            visible={showNoticeVisible}
            setVisible={setShowNoticeVisible}
            event={event}
            doGetClassNotice={doGetClassNotice}
            isTutor={isTutor}
            className={className}
          />
      }
    </Block>
  );
}

export default ClassNotice;
